import { LoadingButton } from "@mui/lab";
import { Card, CardContent, Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Stack, Typography, Button, Grid, Chip, Divider, LinearProgress } from "@mui/material";

import moment from "moment";
import { FileTypeIcon } from "../../common/components/FileTypeIcon";
import ProgramFileUploadComponent from "../programFileUpload/programFileUpload";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { IVideoLessionProgramProps, IVideoLessionFile, IVideoLessionFileDeleteRequest, IVideoLessionFileUploadRequest, IVideoLessionProgramFilter } from "./VideoLessionFileModels";
import VideoLessionFileService from "./videoLessionFileService";
import { useParams } from "react-router-dom";
import { IProgramSubject, Subjects, SubjectsData } from "../../common/data/subjects";
import { VideoLessionPrograms } from "../../common/data/videoLessionPrograms";
import { VideoLessionProgramSubjects } from "./videoLessionProgramSubjects";

export const VideoLessionProgram = (props: IVideoLessionProgramProps) => {
    const { isAddFilesVisible, isDeleteFilesVisible } = props;
    const { filterName } = useParams();

    const [videoLessionFiles, setVideoLessionFiles] = useState<IVideoLessionFile[]>([]);
    const [fileUploadIsInProgress, setFileUploadIsInProgress] = useState<boolean>(false);
    const [videoLessionProgramFilter, setVideoLessionProgramFilter] = useState<IVideoLessionProgramFilter>();
    const [filesLoading, setFilesLoading] = useState<boolean>(false);
    const loadFiles = (filter: IVideoLessionProgramFilter) => {
        if (filter) {
            setFilesLoading(true);
            VideoLessionFileService.getFiles(filter.filterId).then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(
                        result.data.errors[0].message
                    )
                }
                else {
                    setVideoLessionFiles(result.data.list);
                }
            }).finally(() => {
                setFilesLoading(false);
            });
        }
    }
    useEffect(() => {
        const filterNameDecoded = decodeURIComponent(filterName || "");
        const videoLessionProgramFilter = VideoLessionPrograms.find(i => i.filterName === filterNameDecoded) as IVideoLessionProgramFilter;
        setVideoLessionProgramFilter(videoLessionProgramFilter);
        loadFiles(videoLessionProgramFilter);
    }, [filterName]);
    const handleFileUpload = (subjectId: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFiles = Array.from(e.target.files || []);
        setFileUploadIsInProgress(true);
        VideoLessionFileService.fileUpload(uploadedFiles, { subjectId: subjectId, filterId: videoLessionProgramFilter?.filterId } as IVideoLessionFileUploadRequest)
            .then((response) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in uploading the files");
                }
                else {
                    setVideoLessionFiles([...videoLessionFiles, ...response.data.list]);
                }
            }).finally(() => {
                setFileUploadIsInProgress(false);

            });
    }

    const handleFileDelete = (fileDetails: IVideoLessionFile) => {

        const programFiles = videoLessionFiles;
        const fileIndex = programFiles.findIndex(i => i.fileId === fileDetails.fileId);
        programFiles[fileIndex] = { ...fileDetails, isDeleteInProgress: true };
        setVideoLessionFiles(programFiles);

        VideoLessionFileService.deleteFile({ fileId: fileDetails.fileId } as IVideoLessionFileDeleteRequest)
            .then((response) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in deleting the files");
                }
                else {
                    const programFilesData = videoLessionFiles.filter(i => i.fileId !== fileDetails.fileId);
                    setVideoLessionFiles([...programFilesData]);
                    toast.success("file deleted successfully");
                }
            }).finally(() => {


            });
    }


    return (<>

        <Grid container sx={{ height: "100%" }}>
            <Grid item xs={12}>
                <Card sx={{ height: "100%" }}>
                    {/* Page header */}
                    <Box sx={{ px: 3, pt: 2.5, pb: 1.5, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                {videoLessionProgramFilter?.filterName ?? 'Video Lesson Files'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                                Video Lessons &amp; Resources
                            </Typography>
                        </Box>
                        <Chip
                            label={`${videoLessionFiles.length} file${videoLessionFiles.length !== 1 ? 's' : ''}`}
                            variant="outlined"
                            size="small"
                            color="default"
                        />
                    </Box>
                    <Divider />
                    {filesLoading && <LinearProgress />}
                    <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                        <Box sx={{ width: '100%', flexGrow: 1, bgcolor: 'background.paper', height: '100%' }}>
                            <Box>
                                {videoLessionProgramFilter && <VideoLessionProgramSubjects
                                    videoLessionProgramFilter={videoLessionProgramFilter}
                                    videoLessionProgramFiles={videoLessionFiles}
                                    videoLessionProgramProps={props}
                                    handleFileUpload={handleFileUpload}
                                    handleDelete={handleFileDelete} />
                                }
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>

    </>);
}